import React, { Component, Fragment } from 'react';

import RFQDetails from 'Components/RFQDetails';
import BiddingDetailsCard from 'Components/BiddingDetailsCard';
import BiddingDetails from 'Components/AddTrip/BiddingDetails';
import CargoInformation from 'Components/CargoInformation';
import TripTable from 'Components/TripTable';
import TransportersCard from 'Components/TransportersCard';
import DocumentsCard from 'Components/DocumentsCard';
import { isCoromandel, isDesmet, isDesmetSupplier } from 'Utils/index';
import { ContactDetails } from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT3';
import { CardWrapper } from 'Components/Common/Card/index';
import { Spacer } from 'Components/Common/Spacer/index';
import CardT4 from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT4';
import CardT5 from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT5';
import Tk11Details from 'Components/Tk11Details/index';
class Preview extends Component {
   constructor(props) {
      super(props);
   }

   shouldRenderTCAndOtherDocumentsCard = (rfq) => {
      // rfq && (rfq.type === 6 ? (rfq.rfqDetails && rfq.rfqDetails.multiLevelMovementType === 1) : true)
      const C1 = isDesmet();

      if (C1) {
         return false;
      }

      return rfq && (rfq.type === 6 ? (rfq.rfqDetails && rfq.rfqDetails.multiLevelMovementType === 1) : true)
   }

   render() {
      const {
         rfq,
         trips,
         transporters,
         groups,
         onChange,
         uploadDocument,
         documents,
         packingTypes,
         vehicleTypes,
         vehicleBodyTypes,
         paymentCycles,
         businessVolumes,
         pricingBasis,
         slabs,
         productCategories,
         offset,
         tripsCount,
         editTrip,
         applyFilter,
         showAddTrip,
         fetchNextTrips,
         fetchPreviousTrips,
         removeDocument,
         downloadUploadedFile,
         viewMode,
         tripsType,
         addingTrip,
         hideAddTrip,
         addTrip,
         rfqServiceType,
         deleteAddedTrip,
         secondaryUpToKmList,
         secondaryToLocations,
         addCourierTrip,
         selectedSubPlant,
         allSubPlants,
         selectedSubPlantNames,
         courierTrips,
         courierMovements,
         courierModes,
         courierZones,
         courierSlabs,
         courierOtherCharges,
         downloadTrips,
         rfqBiddingDetails,
         courierTatWeight,
		   courierPriceWeight,
         branchesList,
         rowZones,
         additionalZones,
         colZones,
         YardToYardConstants,
         chaList,
         currencyTypes,
         otherCosts,
         incotermsList,
         costHeadList,
         getCostheads,
         selectedNavBranch,
         depotLocationList,
         plantLocationList,
         fuelTypes,
         spotContractReasons,
         contractTenureList,
         searchGroupsAndTransporters,
         ftlContractTypeList,
         vendorBiddingStatus,
         clusterDetails,
         setContainerTrip
      } = this.props;
      
      return (
         <div>
            <div className="mb-50">
               <RFQDetails
                  onChange={onChange}
                  rfqDetails={rfq.rfqDetails}
                  rfqType={rfq.type}
                  viewMode={viewMode}
                  allSubPlants={allSubPlants}
                  rfq={rfq}
                  selectedSubPlantNames={selectedSubPlantNames}
                  // subPlantName={rfq.subplant_name}
                  selectedSubPlant={selectedSubPlant}
                  // selectedSubPlant={rfq.subplant_name}
                  chaList={chaList}
                  pricingBasis={pricingBasis}
                  fuelTypes = { fuelTypes }
                  selectedNavBranch = {selectedNavBranch}
                  spotContractReasons = { spotContractReasons }
                  contractTenureList={contractTenureList}
                  searchGroupsAndTransporters={searchGroupsAndTransporters}
                  ftlContractTypeList={ftlContractTypeList}
                  vendorBiddingStatus={vendorBiddingStatus}
               />
            </div>
            {rfq.type !== 6 && <div className="mb-50">
               <BiddingDetailsCard
                  onChange={onChange}
                  rfqDetails={rfq.rfqDetails}
                  viewMode={viewMode}
               />
            </div>}
            {isCoromandel() && <div className="mb-50">
               <Tk11Details
                  viewMode={viewMode}
                  onChange={onChange}
                  rfqDetails={rfq.rfqDetails}
               />
            </div>
            }
            <div className="mb-50">
               <CargoInformation
                  onChange={onChange}
                  cargoInfo={rfq.cargoInfo}
                  packingTypes={packingTypes}
                  productCategories={productCategories}
                  viewMode={viewMode}
                  rfqType={rfq.type}
                  material_packing_list = {rfq.rfqDetails.material_packing_list}
               />
            </div>


            {isDesmet() && <Fragment>
               <CardWrapper>
                  <ContactDetails
                     contact_details={rfq.rfqDetails.contact_details}
                  />
               </CardWrapper>
               {/* <Spacer spacing={"10px"} />
               <CardT4
                  supplier_docs={rfq.rfqDetails.supplier_docs}
                  downloadUploadedFile={this.downloadUploadedFile}
               /> */}
               <Spacer spacing={"10px"} />
               <CardT5
                  supplier_instruction={rfq.rfqDetails.supplier_instruction}
               // handleOnChangeForSupplierInstruction={
               //    this.handleOnChangeForSupplierInstruction
               // }
               />
            </Fragment>}


            <div className="mb-50 box-shadow ph-20 pv-20 br-5">
               <div className="fBold fs-22 border-bottom-light lh-40p mb-30">
                  Bidding Details
                    </div>
               <BiddingDetails
                  biddingDetails={rfq.biddingDetails}
                  onChange={onChange}
                  paymentCycles={paymentCycles}
                  businessVolumes={businessVolumes}
                  pricingBasis={pricingBasis}
                  slabs={slabs}
                  viewMode={viewMode}
                  viewType="rfq"
                  rfq={rfq}
                  systemTime={this.props.systemTime}
                  rfqType={rfq.type}
                  incotermsList={incotermsList}
               />
            </div>
            <div className="mb-50">
               <TripTable
                  rfq={rfq}
                  tripsCount={tripsCount}
                  editTrip={editTrip}
                  applyFilter={applyFilter}
                  showAddTrip={showAddTrip}
                  trips={trips || []}
                  fetchNextTrips={fetchNextTrips}
                  fetchPreviousTrips={fetchPreviousTrips}
                  offset={offset}
                  vehicleTypes={vehicleTypes}
                  vehicleBodyTypes={vehicleBodyTypes}
                  viewMode={viewMode}
                  tripsType={tripsType}
                  rfqType={rfq.type}
                  secondaryContractType={rfq.rfqDetails.secondaryContractType}
                  addingTrip={addingTrip}
                  hideAddTrip={hideAddTrip}
                  addTrip={addTrip}
                  rfqServiceType={rfqServiceType}
                  deleteAddedTrip={deleteAddedTrip}
                  secondaryUpToKmList={secondaryUpToKmList}
                  secondaryToLocations={secondaryToLocations}
                  addCourierTrip={addCourierTrip}
                  courierMovements ={courierMovements}
                  courierModes = {courierModes}
                  courierZones = {courierZones}
                  courierTrips={courierTrips}
                  courierSlabs={courierSlabs}
                  courierOtherCharges={courierOtherCharges}
                  downloadTrips={downloadTrips}
                  rfqBiddingDetails={rfqBiddingDetails}
                  rfqDetails={rfq.rfqDetails}
                  courierTatWeight={courierTatWeight}
						courierPriceWeight={courierPriceWeight}
                  branchesList ={branchesList}
                  rowZones={rowZones}
                  additionalZones={additionalZones}
                  colZones={colZones}
                  transporters={groups}
                  businessVolumes={businessVolumes}
                  YardToYardConstants={YardToYardConstants}
                  currencyTypes={currencyTypes}
                  otherCosts={otherCosts}
                  costHeadList={costHeadList}
                  selectedNavBranch={selectedNavBranch}
                  depotLocationList={depotLocationList}
                  plantLocationList={plantLocationList}
                  groups={groups || []}
                  onChangeProductTrips={this.props.onChangeProductTrips}
                  clusterDetails={clusterDetails}
                  setContainerTrip={setContainerTrip}
               />
            </div>
            {rfq && rfq.type !== 9 && (rfq.type === 6 ? (rfq.rfqDetails && rfq.rfqDetails.multiLevelMovementType === 1) : true) &&
            <div className="mb-50">
               <TransportersCard
                  transporters={transporters}
                  rfq={rfq} groups={groups || []}
                  viewMode={viewMode}
               />
            </div>}
            {this.shouldRenderTCAndOtherDocumentsCard(rfq)  &&
               <div className="mb-50">
               <DocumentsCard
                  rfqDetails={rfq.rfqDetails}
                  removeDocument={removeDocument}
                  downloadUploadedFile={downloadUploadedFile}
                  documents={rfq.documents}
                  uploadDocument={uploadDocument}
                  viewMode={viewMode}
               />
            </div>}

         </div>
      )
   }
}

export default Preview;
